import React from 'react';
import { 
    Container, Row, Col
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faFileAlt } from '@fortawesome/free-regular-svg-icons'

function JournalOrCalendar(props) {

    if (!props.shown) {
        return <React.Fragment />;
    }
    else {
        return (
            <Container fluid style={{'marginTop': '20px'}}>
                <Row>
                    <Col className="text-center">
                        <FontAwesomeIcon style={{color:'#0275d8', cursor:'pointer'}} onClick={props.journalClicked} size="6x" icon={faFileAlt} /><br />
                        <p style={{fontVariant: 'small-caps', fontWeight: 'bold'}}>journal</p>
                    </Col>
                    <Col className="text-center">
                        <FontAwesomeIcon style={{color:'#0275d8', cursor:'pointer'}} onClick={props.calendarClicked} size="6x" icon={faCalendarAlt} /><br />
                        <p style={{fontVariant: 'small-caps', fontWeight: 'bold'}}>kalender</p>
                    </Col>                   
                </Row>
            </Container>
        );
    }

}

export default JournalOrCalendar;